// Brand assets (uploaded by client)
export const ASSETS = {
  logoFull: "/brand/logo-tight.png",
  logoIcon: "/brand/icon.png",
  teamPhoto: "/brand/team.jpg",
};

export const CONTACT = {
  phone: "481 18 300",
  phoneRaw: "48118300",
  email: "kenneth@hoie-service.no",
  address: "Flatåsen 2, 5550 Sveio",
  company: "Høie Service AS",
  orgNr: "931 774 808",
};
